
import { LoginComponent } from 'login';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'painel', loadChildren: ()=> import('./inicio/inicio.module').then((m)=>m.InicioModule),
    data: {
      breadcrumb: {
        label: 'Inicio',
        info: 'home'
      }
    }
  },
  { path: '', component: LoginComponent },
  { path: '**', redirectTo: 'painel' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
